import { apiPrjCoordSysList } from "@/apis/api";

import {
  apiServerQueryUpdataDetail,
  apiJudgePrjCoordSys,
  apiGetMapLayerName,
} from "@/apis/mapedit-api.js";

import Vue from "vue";
import { Loading } from "element-ui";

const state = {
  openSplitScreen: false, //分屏
  openUseRoll: false, //是否打开卷帘对比
  showServiceTable: false,
  currentBaseMapIndex: 0, //当前激活地图集合图层索引
  baseMapLayersGroup: [], //底图图层集合数据
  specialLayers: [], //专题图层数据
  mapMode: "2d", //地图模式 2d/3d/23d三种模式,
  isShowAllScreen: false, //是否全屏
  isShowLegend: false, //是否显示图例
  isShowMenu: true, //是否显示左侧菜单
  geojsonDataFlag: false, //底部查询详情列表是否显示
  isShowUploadBtn: false,
  currentActiveLayerIndex: null, //当前默认激活layerId vuex不适合存放复杂对象
  showBufferFlag: false, //是否显示缓冲区分析
  showListPop: false,
  showLocation: false, //是否显示地图定位
  acitveDis: APPCONFIG.InitDis, //初始化时的行政区划
  districtLayer: null, //行政区划图层
  currentMapState: null, //当前地图CRS
  curMap: null, //编辑地图时激活的地图
  isShowMapEditPanel: false, //是否显示在线制图面板
  isShowStylePanel: false, //是否显示专题风格面板
  isShowSharePanel: false, //是否显示配图分享面板
  isShowRegisterPanel: false, //是否显示配图注册面板
  isSymbolLibraryPanel: false, //是否显示符号库面板
  isShowDJQuery:false,//是否显示地籍查询
  selectLayer: {
    layerType: null,
    id: null,
    dataSetType: null
  }, //地图编辑选中图层的id和themesetting的layerType
  isShowSpaceTime: false,
  showRightButtonControl: false,
  lastMapPosition: {
    mapMode: "2d",
    center: null,
    zoom: 0
  }, //用以保存在地图切换时地图的上一个最终位置
  mapView: {
    centerX: 0,
    centerY: 0,
    zoom: 1
  }, //记录地图的中心点和缩放级别
  mapTags: [], //在线制图地图标签
  mapName: "无标题", //在线制图地图的名字
  serverList: [], //属性与文档服务数据
  isShowPath: false, // 路径分析面板
  isAllowPath: true, // 是否开启路径分析
  showStreetTool: false, // 街景-工具条显隐
  isSelectStreet: false, // 街景-选中状态
  miniMap: {
    map: {},
    index: ""
  }, // 街景-鹰眼底图数据
  showModifyPanel: false, //纠错面板展示
  queryIsEs: false, // 兴趣点查询是否为es
  mapTablistMode: "spatial", //展示的内容面板类型  spatial为空间查询结果/statics为统计查询结果/query为单纯属性查询结果
  showUploadMenu: false, //是否展示上传数据集菜单
  isShowTsVersionCtrl: false, //是否显示时空服务版本切换框
  checkVersion: {}, //时空服务选中的版本
  isTsservice: false, //是否是时空服务
  openLocation: false, //打开固定定位 true 打开 false 关闭
  //坐标系信息
  prjCoordSysList: [],
  resourceId: "",
  resID: "",
  isOnlineAnalysis: false,
  currentAnalysisDatasetInfo: [],
  slideResourceWidth: APPCONFIG.sideWidth,
  heartMapStyle: null,
  themeSettings: {},
};

const actions = {
  getPrjCoordSys({ commit }) {
    return new Promise(async (resolve, reject) => {
      const { data } = await apiPrjCoordSysList();
      if (data.resultInfo.success) {
        commit("addPrjCoordSys", data.resultInfo.data);
        resolve(data.resultInfo.data);
      } else {
        reject();
      }
    });
  },
  initUploadRestMap({ dispatch, commit, state }, dataInfo) {
    let loadingInstance = Loading.service({
      target: "#app",
      text: "地图加载中......",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    //在线编辑列表图层点击叠加上图
    return new Promise((resolve, reject) => {
      // 1.请求iserver地址并进一步判断图层信息
      apiServerQueryUpdataDetail(dataInfo.datasetid)
        .then((iserver) => {
          if (iserver && iserver.data && iserver.data.resultInfo.success) {
            return iserver.data.resultInfo.data;
          } else {
            reject(iserver.data.resultInfo.message || "请求图层信息失败");
          }
        })
        .then((url) => {
          // 2.根据iserver地址请求图层信息判断是否可叠加
          apiJudgePrjCoordSys(url).then((res) => {
            let result = res.data;
            if (result.error) {
              let msg =
                result.error.code == 404
                  ? "数据完成已入库，等待服务器刷新，请稍后10秒再次点击该图层"
                  : result.error.errorMsg;
              loadingInstance.close();
              reject(msg);
            } else {
              //初始化新的叠加图层数据前先清除以前的
              // let code = result.prjCoordSys.epsgCode;
              // let proj = state.baseMapLayersGroup[0].projection;
              // 底图和叠加图层坐标系一致
              // if (proj.includes(code)) {
                //3.可以叠加，通过url请求layerName,并、添加到editMapLayer
                apiGetMapLayerName(url)
                  .then((layerData) => {
                    let layerInfo = layerData.data[0].subLayers.layers[0]
                    let layer = {
                      bounds: [
                        [result.bounds.top, result.bounds.left],
                        [result.bounds.bottom, result.bounds.right]
                      ],
                      center: [result.center.x, result.center.y],
                      url: url,
                      layerType: "SMRESTMAP",
                      originalLayerType: "SMRESTMAP",
                      layerName: "0:0",
                      name: layerInfo.datasetInfo.name,
                      opacity: 1,
                      dataset: {
                        datasetId: dataInfo.datasetid,
                        datasetName: layerInfo.datasetInfo.dataSourceName,
                        datasetType: layerInfo.datasetInfo.type,
                        mapId: "",
                        datasetFrom: 2
                      },
                      visible: true,
                      resID: dataInfo.pkid,
                      id: dataInfo.pkid,
                      restLayer: url
                    };
                    commit("addLayer", layer);
                    resolve(layer)
                  })
                  .finally(() => {
                    //5.初始化图层属性要素列表
                    loadingInstance.close();
                  })
                  .catch((err) => reject(err));
              // } else {
              //   loadingInstance.close();
              //   reject("当前叠加的图层投影与底图不同，无法叠加");
              // }
            }
          }).catch(() => {
            loadingInstance.close();
            reject("请求图层信息失败");
          });
        })
        .catch(() => {
          loadingInstance.close();
          reject("请求图层信息失败");
        });
    });
  },
};

const mutations = {
  getResID(state, id) {
    state.resID = id;
  },
  getResourceId(state, id) {
    state.resourceId = id;
  },
  getAnalysisStatus(state, status) {
    state.isOnlineAnalysis = status;
  },
  addPrjCoordSys(state, list) {
    state.prjCoordSysList = list;
  },
  changeShowServiceTable(state, flag) {
    state.showServiceTable = flag;
  },
  changeOpenLocation(state) {
    state.openLocation = !state.openLocation;
  },
  judgeSerIsTsservice(state, flag) {
    state.isTsservice = flag;
  },
  changeVersion(state, param) {
    state.checkVersion = param;
  },
  changeIsEs(state, flag) {
    state.queryIsEs = flag;
  },
  changeShowModifyPanel(state, flag) {
    state.showModifyPanel = flag;
  },
  handleMiniMap(state, flag) {
    state.miniMap = flag;
  },
  handleMiniMapIndex(state, index) {
    state.miniMap.index = index;
  },
  handleStreetSelect(state, flag) {
    state.isSelectStreet = flag;
  },
  handleStreetTool(state, flag) {
    state.showStreetTool = flag;
  },
  handleAllowPath(state, flag) {
    state.isAllowPath = flag;
  },
  changePathShow(state, flag) {
    state.isShowPath = flag;
  },
  changeManageMap(state, layer) {
    state.curMap = layer;
  },
  addDistrictLayer(state, layer) {
    state.districtLayer = layer;
  },
  removeDistrictLayer(state) {
    state.districtLayer = null;
  },
  changeDistrict(state, district) {
    state.acitveDis = district;
  },
  changListShow(state, flag) {
    state.showListPop = flag;
  },
  changeCurrentActiveLayer(state, index) {
    state.currentActiveLayerIndex = index;
  },
  changeUploadBtn(state, flag) {
    if (flag && state.showBufferFlag) {
      state.showBufferFlag = false;
    }
    state.isShowUploadBtn = flag;
  },
  changeGeoJsonDataFlag(state, flag) {
    state.geojsonDataFlag = flag;
  },
  changeShowMenu(state, isShowMenu) {
    state.isShowMenu = isShowMenu;
  },
  showHideLegend(state, isShowLegend) {
    state.isShowLegend = isShowLegend;
  },
  showHidedjQuery(state, isShowDJQuery) {
    state.isShowDJQuery = isShowDJQuery;
  },
  changeMapMode(state, mapMode) {
    state.mapMode = mapMode;
  },
  changeShowAllScreen(state, isShowAllScreen) {
    state.isShowAllScreen = isShowAllScreen;
  },
  addBaseMapLayersGroup(state, baseMapLayersGroup) {
    state.baseMapLayersGroup = baseMapLayersGroup;
  },
  addLegend(state, { layer, legend }) {
    for (let i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].id == layer.id) {
        state.specialLayers[i].legend = legend;
        break;
      }
    }
  }, // 给专题图添加图例
  removeLegend(state, id) {
    let layer = state.specialLayers.find(item => item.id == id);
    if (layer) {
      layer.legend = [];
    }
  }, // 移除专题图图例
  addLayer(state, layer) {
    if (
      layer.layerType == "SMRESTMAP" ||
     (layer.originalLayerType&& layer.originalLayerType == "SMRESTMAP") ||
      layer.layerType.includes("SFS") ||
      (layer.originalLayerType&&layer.originalLayerType.includes("SFS"))
    ) {
      if (!state.isShowMapEditPanel) {
        state.showRightButtonControl = true;
      }
    }
    let flag = state.specialLayers.filter(item => {
      //原始唯一标识应使用key，为向下兼容保留resID
      return item.resID == layer.resID && item.key == layer.key;
    });
    if (flag.length == 0) {
      //默认设置zIndex 方便后续调整图层顺序
      layer.zIndex =
        state.specialLayers.length == 0
          ? 10
          : (state.specialLayers.length + 1) * 10;
      state.specialLayers.push(layer);
    } else {
      flag[0].url = layer.url;
      flag[0].layerName = layer.layerName;
      flag[0].layerType = layer.layerType;
      flag[0].options = layer.options;
      flag[0].opacity = layer.opacity;
      flag[0].visible = layer.visible;
      flag[0].id = layer.id;
      flag[0].legend = layer.legend;
      flag[0].restLayer = layer.restLayer;
      if (APPCONFIG.MuleSubdomains) flag[0].urlTemplate = layer.urlTemplate;
    }
  },
  removeAllSLayer(state, clearAllFlag) {
    if (clearAllFlag) {
      state.specialLayers = [];
    } else {
      state.specialLayers = state.specialLayers.filter(layer => {
        return layer.noClear;
      });
    }
  },
  removeLayer(state, layer) {
    if (state.specialLayers.length == 1) {
      state.showRightButtonControl = false;
    }
    for (let i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].resID == layer.resID) {
        state.specialLayers.splice(i, 1);
        for (let j = 0; j < state.specialLayers.length; j++) {
          if (
            state.specialLayers[j].layerType == "SMRESTMAP" ||
            state.specialLayers[j].originalLayerType == "SMRESTMAP" ||
            state.specialLayers[j].layerType.includes("SFS") ||
            state.specialLayers[j].originalLayerType.includes("SFS")
          ) {
            if (!state.isShowMapEditPanel) {
              state.showRightButtonControl = true;
            }
            break;
          } else if (state.isShowMapEditPanel) {
            state.showRightButtonControl = false;
          }
        }
      }
    }
  },
  removeLayerByUrl(state, url) {
    for (let i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].url == url) {
        state.specialLayers.splice(i, 1);
        break;
      }
    }
  },
  removeLayerByKey(state, key) {
    for (let i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].key == key) {
        state.specialLayers.splice(i, 1);
        break;
      }
    }
  },
  showHideLayer(state, { layer, flag }) {
    for (let i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].id == layer.id) {
        state.specialLayers[i].visible = flag;
        break;
      }
    }
  },
  changeSpecialLayer_(state, specialLayer) {
    let hasCurLayer = false;
    for (var i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].id == specialLayer.id) {
        state.specialLayers.splice(i, 1, specialLayer);
        hasCurLayer = true;
        break;
      }
    }
    if (!hasCurLayer) {
      state.specialLayers.push(specialLayer);
    }
  },
  changeLayerOpacity(state, { layer, opacity }) {
    for (var i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].id == layer.id) {
        state.specialLayers[i].opacity = opacity;
      }
    }
  },
  changeCurrentBaseMapIndex(state, index) {
    state.currentBaseMapIndex = index;
    let templayer = state.baseMapLayersGroup[0];
    Vue.set(state.baseMapLayersGroup, 0, state.baseMapLayersGroup[index]);
    Vue.set(state.baseMapLayersGroup, index, templayer);
  },
  changeLayerZIndex(state, { downLayer, upLayer }) {
    for (let i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].resID == downLayer.resID) {
        var templayer = state.specialLayers[i];
        for (let j = 0; j < state.specialLayers.length; j++) {
          if (state.specialLayers[j].resID == upLayer.resID) {
            Vue.set(state.specialLayers, i, state.specialLayers[j]);
            Vue.set(state.specialLayers, j, templayer);
            break;
          }
        }
      }
    }
  },
  changeBufferState(state, bufferState) {
    if (bufferState && state.isShowUploadBtn) {
      state.isShowUploadBtn = false;
    }
    state.showBufferFlag = bufferState;
  },
  changeLocationState(state, locationState) {
    state.showLocation = locationState;
  },
  storeCurrentMapState(state, crs) {
    state.currentMapState = crs;
  },
  changeShowMapEditPanel(state, isShowMapEditPanel) {
    state.isShowMapEditPanel = isShowMapEditPanel;
  },
  changeShowStylePanel(state, isShowStylePanel) {
    state.isShowStylePanel = isShowStylePanel;
  },
  changeShowSharePanel(state, isShowSharePanel) {
    state.isShowSharePanel = isShowSharePanel;
  },
  changeShowRegisterPanel(state, isShowRegisterPanel) {
    state.isShowRegisterPanel = isShowRegisterPanel;
  },
  changeShowSymbolLibraryPanel(state, isSymbolLibraryPanel) {
    state.isSymbolLibraryPanel = isSymbolLibraryPanel;
  },
  removeThemeItem(state, id) {
    for (var i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].id == id) {
        state.specialLayers.splice(i, 1);
        break;
      }
    }
    // for(var i=0;i<state.themeLayers.length;i++){
    //   if(state.themeLayers[i].id == id){
    //     state.themeLayers.splice(i, 1);
    //     break;
    //   }
    // };
  },
  addToThemeLayer(state, item) {
    state.themeLayers.push(item);
  },
  removeThemeLayerByResID(state, resID) {
    for (var i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].resID == resID) {
        state.specialLayers.splice(i, 1);
        break;
      }
    }
  },
  /**
   * 添加不在底图数组里面的底图，且不影响已有的底图切换
   */
  changeOtherBaseMap(state, item) {
    EventBus.$emit("beforeBaseMapChange");
    let _item = JSON.parse(JSON.stringify(item));
    _item.isOtherMap = true;
    for (let i = 0; i < state.baseMapLayersGroup.length; i++) {
      if (state.baseMapLayersGroup[i].isOtherMap) {
        state.baseMapLayersGroup.splice(i, 1);
      }
    }
    if (_item.type == "scene") {
      state.mapMode = "3d";
    } else {
      state.mapMode = "2d";
    }
    state.baseMapLayersGroup.unshift(_item);
  },
  changeSpaceTimeVisible(state, flag) {
    state.isShowSpaceTime = flag;
  },
  changeVersionCtrlVisible(state, flag) {
    state.isShowTsVersionCtrl = flag;
  },
  toggleRightButtonControlVisible(state, flag) {
    state.showRightButtonControl = flag;
  },
  storeLastMapPosition(state, position) {
    state.lastMapPosition = position;
  },
  changeMapView(state, mapView) {
    state.mapView = mapView;
  },
  changeMapTags(state, tags) {
    state.mapTags = tags;
  },
  addMapTags(state, tag) {
    state.mapTags.push(tag);
  },
  deleteMapTags(state, index) {
    state.mapTags.splice(index, 1);
  },
  changeMapName(state, name) {
    state.mapName = name;
  },
  //地图定制专用
  changeSelectLayer(state, obj) {
    state.selectLayer = obj;
  },
  clearSelectLayer(state) {
    state.selectLayer.layerType = null;
    state.selectLayer.id = null;
    state.selectLayer.dataSetType = null;
  },
  changeSpecilayerAttr(state, obj) {
    var newlayer = state.specialLayers.find(layer => layer.id == obj.id);
    if (obj.typeReduct == "reduct") {
      if (newlayer) {
        delete newlayer.serverThemeSettings;
        delete newlayer.themeSettings;
        delete newlayer.dataSetType;
        newlayer.layerType = newlayer.originalLayerType;
        return
      }
    }
    for (let key in obj) {
      if (key != "id") {
        Vue.set(newlayer ? newlayer : [], key, obj[key]);
      }
    }
  },
  changeSpecialLayer(state, specialLayer) {
    let hasCurLayer = false;
    for (var i = 0; i < state.specialLayers.length; i++) {
      if (state.specialLayers[i].id == specialLayer.id) {
        state.specialLayers.splice(i, 1, specialLayer);
        hasCurLayer = true;
        break;
      }
    }
    if (!hasCurLayer) {
      state.specialLayers.push(specialLayer);
    }
  },
  changeServerList(state, serverList) {
    Vue.set(state, "serverList", serverList);
  },
  changeTableType(state, flag) {
    state.mapTablistMode = flag;
  },
  toggleFlag(state, par) {
    state[par.name] = par.flag;
  },
  changeSplitScreen(state, openSplitScreen) {
    state.openSplitScreen = openSplitScreen;
  },
  // 卷帘
  changeUseRoll(state, openUseRoll) {
    state.openUseRoll = openUseRoll;
  },
  changeCurrentAnalysisDatasetInfo(state, info) {
    state.currentAnalysisDatasetInfo = info;
  },
  changeSlideResourceWidth(state, data) {
    state.slideResourceWidth = data;
  },
  setHeartMapStyle(state, data) {
    state.heartMapStyle = data;
  },
  setMapThemeSettings(state, options) {
    Vue.set(state.themeSettings, options.id, options);
  },
  removeAllMapThemeSettings(state) {
    state.themeSettings = {}
  }
};

export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/map.js